// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3SRLb","sendOtp":"AuthorizeToLogin_sendOtp__2WTsE"};